<template>
    <div class="view view--add-wallpaper">
        <add-wallpaper />
    </div>
</template>

<script>
    import addWallpaper from '../../components/AddWallpaper.vue';

    export default {
        components: {
            addWallpaper
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/wallpapers/Add.vue